import { curry } from 'ramda';

export const higherOrderName = curry((wrapper, C, hoc) => {
  hoc.displayName = C?.displayName ? `${wrapper}(${C?.displayName})` : wrapper;

  return hoc;
});
